import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'x-badge',
  templateUrl: './badge.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'x-badge',
  },
})
export class BadgeComponent {
  @Input()
  public badge?: string | null;

  @Input()
  public badgeIconUrl?: string | null;

  @HostBinding('class.x-icon-badge')
  get isIconBadge() {
    return !!this.badgeIconUrl;
  }
}
